<shared-modal-type-dynamic-height [size]="size" [footer]="footer" [modalData]="modalData" size="sm"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-auth" [shadowBottom]="(authenticationStep$ | async) == 4"
    [dynamicHeight]="(authenticationStep$ | async) !== 15">

    <div class="modal-for-auth__content">

        <shared-auth [modalData]="modalData" [memberId]="modalData?.memberId || null"
            [locationNo]="modalData?.locationNo || null" [orderId]="modalData?.orderId || null"
            (onUpdate)="handleStepChange($event)"></shared-auth>

    </div>

</shared-modal-type-dynamic-height>

<ng-template #footer>
    <ng-container *ngIf="(authenticationStep$ | async) == 4">

        <ng-template #left>
            <shared-forms-terms (onClick)="handleTermsClick($event)"></shared-forms-terms>
        </ng-template>

        <ng-template #right>
            <shared-forms-submit [loading]="loading$ | async" class="modal-for-auth__submit" marginTop="none"
                width="normal" [parentForm]="formControl" formName="sign-up">
                Create account
            </shared-forms-submit>
        </ng-template>

        <shared-two-columns class="modal-for-auth__ft" [left]="left" [right]="right" align="left">
        </shared-two-columns>
    </ng-container>

</ng-template>
